export default function getCurrentSchoolYear() {
  const currentMonth = new Date().getMonth() + 1;
  return currentMonth < 8 ? `${new Date().getFullYear() - 1}-${new Date().getFullYear()}` : `${new Date().getFullYear()}-${new Date().getFullYear() + 1}`
}